<template>
  <div>
    <global-header />
    <article>
      <router-view />
    </article>
  </div>
</template>

<script>
import GlobalHeader from "@/components/molecules/GlobalHeader";

export default {
  name: "LayoutsDefault",
  components: {
    GlobalHeader,
  },
};
</script>
